export default __webpack_public_path__ + "static/media/2101.388e700f.jpg";